import { useFeatureFlagSplit } from '@verantos-dev/app-state-base';
import type { CohortVersionParams } from '@verantos-dev/feature-analytical-variables';

import { useCohortDefinitionDataExplicitSave } from './useCohortDefinitionDataExplicitSave';
import { useCohortDefinitionDataLegacy } from './useCohortDefinitionDataLegacy';

/**
 * Orchestrates TanStack Query → Zustand sync for cohort definition data.
 * Dispatches to the explicit_save or legacy implementation based on the FF.
 *
 * Both sub-hooks are always invoked (rules of hooks) — the inactive one is
 * disabled via the `enabled` flag so it doesn't fetch.
 */
export const useCohortDefinitionData = (params: CohortVersionParams & { enabled?: boolean }) => {
  // TODO: cleanup with explicit_save ff — return useCohortDefinitionDataExplicitSave(params)
  const isExplicitSave = useFeatureFlagSplit('explicit_save') === true;
  const isEnabled = params.enabled !== false;

  const explicit = useCohortDefinitionDataExplicitSave({
    ...params,
    enabled: isEnabled && isExplicitSave,
  });
  const legacy = useCohortDefinitionDataLegacy({
    ...params,
    enabled: isEnabled && !isExplicitSave,
  });

  return isExplicitSave ? explicit : legacy;
};
